export class ModalRemoverEncomendaSelecionadaController {
  constructor($scope, $uibModalInstance, pedido) {
    'ngInject';

    $scope.pedido = pedido;

    $scope.nao = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.sim = function() {
      $uibModalInstance.close($scope.pedido);
    };
  }
}
